import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import { Backdrop, ControlHeight, OverlayChildren } from './styled';

const Overlay = ({ isOpen, onClose, children, overlayHeight }) => {
  const ref = useRef();
  const controlRef = useRef();

  const { height: windowHeight } = useWindowSize();
  const [childrenHeight, setChildrenHeight] = useState(0);

  const elementHeight = controlRef?.current?.clientHeight;
  const barHeight = elementHeight - windowHeight;

  useLayoutEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.height = '100%';
    }
    return () => {
      document.body.style.overflow = null;
      document.documentElement.style.height = null;
    };
  }, [isOpen]);

  useEffect(() => {
    if (overlayHeight > 0) {
      const childrenNum = (overlayHeight + 60) / windowHeight;
      const childrenPercentage = Math.floor(childrenNum * 100);
      setChildrenHeight(childrenPercentage);
    }
  }, [overlayHeight]);

  const variants = {
    visible: {
      pointerEvents: 'initial',
      opacity: 1
    },
    hidden: {
      pointerEvents: 'none',
      opacity: 0
    }
  };

  const onClick = (event) => {
    // call onClose only when a child was not clicked
    if (ref.current && event.target === ref.current) {
      onClose();
    }
  };

  return (
    <Backdrop
      gradientPercentage={childrenHeight}
      initial="hidden"
      animate={isOpen ? 'visible' : 'hidden'}
      variants={variants}
      barHeight={barHeight}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20
      }}
    >
      <ControlHeight ref={controlRef} />
      <OverlayChildren gradientPercentage={childrenHeight} ref={ref} onClick={onClick}>
        {children}
      </OverlayChildren>
    </Backdrop>
  );
};

Overlay.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  overlayHeight: PropTypes.number
};

export default Overlay;
